import axios from "axios";
axios.defaults.maxContentLength = 500000;

let json
try {
    json = localStorage.getItem('user');
} catch (error) {
    console.log(error)
}
const user = json !== 'undefined' && json ? JSON.parse(json) : null;
const Url = process.env.REACT_APP_BASEURL ? process.env.REACT_APP_BASEURL : "https://api.augenengenharia.com/";

const api = axios.create({
    baseURL: Url,
    
    timeout: 30000,
    headers: {'Accept': 'application/json', "Content-Type": "application/json"},
})

// "ngrok-skip-browser-warning" : true
api.defaults.headers.common['Authorization'] = user ? 'Bearer ' +user.access_token : null;

function setJWTToken (token: string){
    api.defaults.headers.common['Authorization'] = 'Bearer ' +token ;
}

export { api, setJWTToken };